module.exports = __webpack_public_path__ + "static/disease-bf14903419091fc4d6998978f9bb3224.png";